import React from "react";
import styles from "../PanelUser/PanelLayout.module.css";
import { Link } from "react-router-dom";
import axiosInstance from "../../api/axiosConfig";

export default function ResumenSede() {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    axiosInstance
      .get("/api/datapersonal", { headers: { Authorization: token } })
      .then((r) => setUser(r.data))
      .catch(console.error);
  }, []);

  const pendientes = user?.InPersonShifts?.filter((s) => s.status === "pendiente") || [];
  const aceptados = user?.InPersonShifts?.filter(
    (s) => s.status === "aceptado" || s.status === "confirmado",
  ) || [];

  const stats = [
    { label: "Turnos pendientes", sub: "por gestionar", value: pendientes.length },
    { label: "Turnos aceptados", sub: "confirmados", value: aceptados.length },
    { label: "Total turnos", sub: "historial", value: user?.InPersonShifts?.length || 0 },
  ];

  const quickActions = [
    { label: "Mis turnos", sub: "Gestión de turnos", to: "/panel/sede/turnos" },
    { label: "Mi perfil", sub: "Datos de la sede", to: "/panel/sede/perfil" },
  ];

  return (
    <>
      <div className={styles.statsGrid} style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
        {stats.map((s) => (
          <div key={s.label} className={styles.statCard}>
            <p className={styles.statValue}>{s.value}</p>
            <p className={styles.statTitle}>{s.label}</p>
            <p className={styles.statSub}>{s.sub}</p>
          </div>
        ))}
      </div>

      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h2 className={styles.cardTitle}>Acciones rápidas</h2>
        </div>
        <div className={styles.quickActions}>
          {quickActions.map((a) => (
            <Link key={a.to} to={a.to} className={styles.quickAction}>
              <span className={styles.quickActionTitle}>{a.label}</span>
              <span className={styles.quickActionSub}>{a.sub}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
